import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { FormModule } from '@woolworthsnz/form';
import { StyleguideModule } from '@woolworthsnz/styleguide';
import { ContactComponent } from './components/contact/contact.component';
import { DetailsHeaderComponent } from './components/details-header/details-header.component';
import { DetailsServiceComponent } from './components/details-service/details-service.component';
import { GoogleStoresMapComponent } from './components/google-stores-map/google-stores-map';
import { OpeningHoursComponent } from './components/opening-hours/opening-hours.component';
import { PharmacyComponent } from './components/pharmacy/pharmacy.component';
import { PinWithNumberComponent } from './components/pin-with-number/pin-with-number.component';
import { SearchCardComponent } from './components/search-card/search-card.component';
import { SearchSummaryComponent } from './components/search-summary/search-summary.component';
import { SeoComponent } from './components/seo/seo.component';

const components = [
	DetailsHeaderComponent,
	DetailsServiceComponent,
	GoogleStoresMapComponent,
	PinWithNumberComponent,
	SearchCardComponent,
	SearchSummaryComponent,
	SeoComponent,
	PharmacyComponent,
	ContactComponent,
	OpeningHoursComponent,
];

@NgModule({
	exports: [...components],
	imports: [CommonModule, StyleguideModule, FormModule, GoogleMapsModule, ...components]
})
export class StoreLocatorLibModule { }
